export default __webpack_public_path__ + "static/media/Emergency Savings.6d07e968.svg";